import styled from "styled-components"

export const Button = styled.button`
  position: fixed !important;
  color: white;
  z-index: 500;
  cursor: pointer;
  border: 0;
  padding: 1.4rem 2.7rem;
  font-size: 1.4rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  position: relative;
  right: 3.5rem;
  bottom: 6.5rem;
  background-color: #eb591a;
  border-radius: 3rem;
  margin: 1rem 0;

  @media (min-width: 426px) {
    right: 7.5rem;
  }
  @media (min-width: 769px) {
    bottom: 1.5rem;
  }
`
